<div *ngIf="listFlag !== 'view'" class="selected-students">
  <table class="table table-sm">
    <thead>
      <tr>
        <th scope="col">
          <div class="selected-students-wrapper">
            <div class="selected-title">
              {{'buses.selected-student-table.selected-students' | translate}}
            </div>
            <div *ngIf="selectedStudentsToAdd?.length > 0" class="selected-count">
              {{selectedStudentsToAdd?.length |arabicNumber:currLang}} {{'buses.selected-student-table.selected' | translate}}
            </div>
          </div>
        </th>
        <th scope="col"><span class="clear-btn" *ngIf="listFlag!=='view'" (click)="clearAll()">{{'buses.selected-student-table.clear-all' | translate}}</span></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let student of selectedStudentsToAdd">
        <td scope="row">
          <img [src]="getImage(student.image_path)" alt="">
          <span>{{student.name}}</span>
        </td>
        <td *ngIf="listFlag !=='view'" (click)="removeFromRoute(student)">
          <svg xmlns="http://www.w3.org/2000/svg" width="14.563" height="17.93" viewBox="0 0 14.563 17.93">
            <g id="bin_1_" data-name="bin (1)" transform="translate(0.003 0.001)">
              <path id="Path_5376" data-name="Path 5376"
                d="M222.818,154.7a.42.42,0,0,0-.42.42v7.936a.42.42,0,1,0,.84,0v-7.936A.42.42,0,0,0,222.818,154.7Zm0,0"
                transform="translate(-213.063 -148.209)" fill="#707070" />
              <path id="Path_5377" data-name="Path 5377"
                d="M104.818,154.7a.42.42,0,0,0-.42.42v7.936a.42.42,0,1,0,.84,0v-7.936A.42.42,0,0,0,104.818,154.7Zm0,0"
                transform="translate(-100.018 -148.209)" fill="#707070" />
              <path id="Path_5378" data-name="Path 5378"
                d="M1.189,5.336V15.682a2.317,2.317,0,0,0,.616,1.6,2.068,2.068,0,0,0,1.5.649H11.25a2.067,2.067,0,0,0,1.5-.649,2.317,2.317,0,0,0,.616-1.6V5.336a1.6,1.6,0,0,0-.412-3.154H10.8V1.657A1.649,1.649,0,0,0,9.142,0H5.414A1.649,1.649,0,0,0,3.751,1.657v.525H1.6a1.6,1.6,0,0,0-.412,3.154ZM11.25,17.088H3.306a1.33,1.33,0,0,1-1.276-1.407V5.373h10.5V15.682a1.33,1.33,0,0,1-1.276,1.407ZM4.59,1.657A.809.809,0,0,1,5.414.838H9.142a.809.809,0,0,1,.823.819v.525H4.59ZM1.6,3.022H12.955a.756.756,0,0,1,0,1.512H1.6a.756.756,0,1,1,0-1.512Zm0,0"
                transform="translate(0)" fill="#707070" />
              <path id="Path_5379" data-name="Path 5379"
                d="M163.818,154.7a.42.42,0,0,0-.42.42v7.936a.42.42,0,1,0,.84,0v-7.936A.42.42,0,0,0,163.818,154.7Zm0,0"
                transform="translate(-156.54 -148.209)" fill="#707070" />
            </g>
          </svg>
        </td>
      </tr>
    </tbody>
  </table>
</div>